var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBottomBird = function SvgArrowBottomBird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1780 1017.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1742.9 37.2-.3-.3c-49.6-49.4-129.8-49.2-179.2.3L890.5 710.4v.2L216.7 37.4C193 13.9 160.9.7 127.5.6 57.3.4.2 57.2 0 127.5c-.1 33.8 13.2 66.3 37.1 90.2l768 766.3c50.1 45.8 127.3 44.2 175.4-3.7l762.4-763c49.5-49.8 49.5-130.3 0-180.1"
  })));
};
export default SvgArrowBottomBird;